/* eslint-disable no-await-in-loop */
import { createCampaign } from '../../fbApi/Campaign';
import { createAdSet } from '../../fbApi/AdSet';
import { createAd } from '../../fbApi/Ad';

export const buildCampaign = async (data, token) => {
  const parameters = {
    access_token: token,
    name: data.name,
    objective: data.objective,
    status: 'PAUSED',
    spend_cap: data.spend_cap,
    buying_type: 'AUCTION',
    lifetime_budget: data.lifetime_budget,
    budget_remaining: data.budget_remaining,
    bid_strategy: 'LOWEST_COST_WITHOUT_CAP'
  };

  // eventually, we will want to give users the option to chose the special ad catgory
  // for now, we only use CREDIT if the campaign is HEC
  if (data.isHecCampaign) {
    parameters.special_ad_categories = 'CREDIT';
  }

  if (data.objective === 'PRODUCT_CATALOG_SALES' || data.productCatalog) {
    parameters.promoted_object = {
      product_catalog_id: data.productCatalog
    };
  }

  if (data.tags) {
    parameters.adlabels = data.tags.split(',').map((tag) => ({
      name: tag.trim()
    }));
  }

  const result = await createCampaign(data.accountId, parameters);
  return result;
};

export const buildAdSet = async (data, token) => {
  const optimizationGoal = data.optimization_goal;
  let destinationType = '';

  if (optimizationGoal) {
    destinationType = optimizationGoal !== 'THRUPLAY' ? 'WEBSITE' : 'UNDEFINED';
  }

  const parameters = {
    access_token: token,
    campaign_id: data.campaignId,
    name: data.name,
    status: data.status,
    start_time: data.start_time,
    end_time: data.end_time,
    destination_type: destinationType,
    optimization_goal: data.optimization_goal,
    targetingsentencelines: data.targetingsentencelines,
    targeting: data.targeting,
    billing_event: 'IMPRESSIONS',
    attribution_spec: data.attribution_spec
  };

  if (data.promoted_object) parameters.promoted_object = data.promoted_object; // this can be overwritten below based on the data.

  if (data.lifetime_budget) {
    parameters.lifetime_budget = data.lifetime_budget;
  }

  if (data.productSet) {
    parameters.destination_type = 'UNDEFINED';
    parameters.promoted_object = {
      custom_event_type: 'CONTENT_VIEW',
      product_set_id: data.productSet
    };
  }

  if (data.objective === 'PRODUCT_CATALOG_SALES') {
    parameters.destination_type = 'UNDEFINED';
    parameters.promoted_object = {
      custom_event_type: 'CONTENT_VIEW',
      product_set_id: data.productSet
    };
  }

  /** Returns below error if failed. Otherwise, returns json with id field.
   * {
        "error": {
            "message": "(#100) Param targeting[custom_audiences][0][id] must be a valid custom audience id",
            "type": "OAuthException",
            "code": 100,
            "fbtrace_id": "E+dRQfZ86QF"
        }
      }
   */
  let result = null;
  let requestFailed = true;
  let errorMessage = '';
  let removedCustomAudience = false;
  for (let i = 0; i < 2 && requestFailed; i += 1) {
    result = await createAdSet(data.accountId, parameters); // unlike createAd() in PackageBuilder.js, we can't display error on the screen if request fails unless we move  this part into PackageBuilder.js.

    if (result.error) {
      // check if the request failed because of custom_audiences.
      // If this is the case, remove the customer_audiences field and re-try.

      errorMessage = result.error.error_user_msg || result.error.message;

      if (parameters.targeting.custom_audiences) {
        delete parameters.targeting.custom_audiences;

        removedCustomAudience = true;
      }

      requestFailed = true;
    } else {
      requestFailed = false;
    }
  }

  if (removedCustomAudience && !requestFailed) {
    // if the custom audience has been removed and request has been sent successfully,
    // the root cause of the request failure was because of the invalid custom audience.
    // Let the user know this in the log.

    result.statusMessage =
      'This adSet has been created without the custom audience.';
    result.errorMessage = errorMessage;
  }

  // trying to match the same format as above when removedCustomAudience is true.
  if (errorMessage !== '') {
    result.errorMessage = errorMessage;
  }

  return result;
};

export const buildAd = async (data, token) => {
  const parameters = {
    access_token: token,
    adset_id: data.adSetId,
    name: data.name,
    status: data.status,
    creative: data.creative,
    tracking_specs: data.tracking_specs,
    conversion_domain: data.conversion_domain
  };

  if (data.objective === 'PRODUCT_CATALOG_SALES' || data.productSet) {
    parameters.creative.product_set_id = data.productSet;
  }

  const result = await createAd(data.accountId, parameters);
  return result;
};



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/CampaignBuilder.js